import { FETCH_TOP_PRODUCTS_BY_CATEGORY, SET_IS_FETCHING_PRODUCTS } from 'reducers/actions-types';
import axios from 'axios';
import { topProducts as topProductsURL } from 'constants/api-urls';
import productsFactoryMiddleware from 'util/misc/products-factory-middleware';

let pendingRequestsCount = 0;

/**
 * Helper function that will set the isFetching flag to false or true if there are still loading requests in the queue
 * @param { funciton } dispatch - redux dispatch function
 */
function setIsFetching(dispatch) {
    pendingRequestsCount--;
    const isFetching = pendingRequestsCount !== 0;
    dispatch({ type: SET_IS_FETCHING_PRODUCTS, isFetching });
}

/**
 * Fetch the products depending on the category
 * @param {ICategory} category
 * @param {string} cooperative
 */
function fetchTopProducts({ category }, cooperative) {
    pendingRequestsCount++;
    return axios.get(topProductsURL(category.id, cooperative)).then(({ data }) => {
        return data;
    });
}

export default Object.freeze({
    /**
     * @param {ICategory} category
     * @return {function(*=, *): Promise<IProduct[] | ICooperativeProduct[] | never>}
     */
    fetchTopProductsByCategory({ category }) {
        return function(dispatch, getState) {
            dispatch({ type: SET_IS_FETCHING_PRODUCTS, isFetching: true });
            const categories = category.children;
            const cooperative = getState().router.cooperative;

            return Promise.all(categories.map(child => fetchTopProducts({ category: child }, cooperative)))
                .then(products => productsFactoryMiddleware(products, { cooperative }))
                .then(products => {
                    setIsFetching(dispatch);
                    dispatch({ type: FETCH_TOP_PRODUCTS_BY_CATEGORY, category, products });
                    return products;
                })
                .catch(() => {
                    setIsFetching(dispatch);
                    dispatch({
                        type: FETCH_TOP_PRODUCTS_BY_CATEGORY,
                        products: [],
                        category,
                    });
                });
        };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/top-products/actions.js